import { Observable } from "@noya-app/observable";
import {
  ClientToServerMessage,
  MultiplayerStateManagerError,
  ServerToClientMessage,
} from "./multiplayer";
import { ReconnectingWebSocketState } from "./ReconnectingWebsocket";

export type ConnectionEvent<S> =
  | {
      type: "stateChange";
      state: ReconnectingWebSocketState;
    }
  | {
      type: "send";
      message: ClientToServerMessage<S>;
    }
  | {
      type: "receive";
      message: ServerToClientMessage<S>;
    }
  | {
      type: "error";
      error: MultiplayerStateManagerError;
    };

export class ConnectionEventManager<S> {
  constructor(public options: { maxEvents?: number } = {}) {}

  events$ = new Observable<ConnectionEvent<S>[]>([]);

  addEvent(event: ConnectionEvent<S>) {
    const existing = this.events$.get();
    const merged = [...existing, event];
    const maxEvents = this.options.maxEvents ?? 50;
    this.events$.set(merged.slice(-maxEvents)); // Take last maxEvents items
  }

  getEvents() {
    return this.events$.get();
  }
}
